import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Supplied by the DMS desktop host via the WebView2 message bridge on /sale-tax and
// /address-validation. Memory-only; excluded from the redux-persist whitelist.
interface EverestAuthState {
  code: string | null;
}

const initialState: EverestAuthState = {
  code: null,
};

const everestAuthSlice = createSlice({
  name: "everestAuth",
  initialState,
  reducers: {
    setEverestAuth: (state, action: PayloadAction<{ code: string }>) => {
      state.code = action.payload.code;
    },
    clearEverestAuth: (state) => {
      state.code = null;
    },
  },
});

export const { setEverestAuth, clearEverestAuth } = everestAuthSlice.actions;
export default everestAuthSlice.reducer;
